export const PROTECTION_PLAN_ATTRIBUTE_NAME = 'Protection plan';
